import * as React from "react"
import { useEffect } from "react"
import { batch } from "@preact/signals-react"
import { Box } from "@mui/material"

import { CommonFilters } from "@components"
import {COMMON_FILTER_KEYS, PRODUCT_PAGE_ROUTES, SHARE_OF_SEARCH_ROUTES} from "@constants"
import { useAppDefaultFilters } from "@hooks"
import { isLoadingCommonFilters, isSystemBusy } from "@signals"
import { useProductPageDetailsRoleConfig } from "./@hooks"
import { productPagesDetailsIsEmpty } from "./@signals"


export default function ProductPagesFilters() {

	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(PRODUCT_PAGE_ROUTES.DETAILS_ID, PRODUCT_PAGE_ROUTES.ACCESS_KEY)

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

	const { isMarketplacesUser } = useProductPageDetailsRoleConfig()

	return <Box data-tour="pp-details-filters">
	<CommonFilters
		components={{
			country: true, site: true,
			category: true, brand: true,
			sku: true, favFilters: true,
			skuGroup: true, seller: !!isMarketplacesUser,
			productsInStock: true
		}}
		compProps={{
			favFilters: {
				grid: { md: 3 },
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
					COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU
				],
				dashboardKey: PRODUCT_PAGE_ROUTES.DETAILS_ID
			},
			productsInStock: { grid: { md: 7 } },
			sku: { grid: { md: isMarketplacesUser ? 4 : 6 } }
		}}
		onSubmit={() => { batch(() => {
			isLoadingCommonFilters.value = true
			productPagesDetailsIsEmpty.value = false
			isSystemBusy.value = false
		})}}
		defaultValues={userFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
	/>
	</Box>
}
